import React, { useEffect, useState } from "react";
import StockChart from "./StockChart";
import styled, { isStyledComponent } from "styled-components";
import axios from "axios";
import "../App.css";
const ContentContainer = styled.div`
  flex: 1;
  padding: 20px;
  background-color: #ecf0f1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Header = styled.div`
  background-color: black;
  color: green;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 20px;
  font-family: 'Share Tech Mono', 'Courier New', monospace;
  text-shadow: 0px 0px 5px green;
`;

const ScrollableCard = styled.div`
  background: black;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 0 15px green;
  width: 400px;
  height: 500px;
  overflow-y: auto;
  transition: all 0.3s ease-in-out;
  color: green;
  font-size: 1.1em;
  font-family: 'Share Tech Mono', 'Courier New', monospace;
  text-shadow: 0px 0px 5px green;
  
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 0 25px limegreen;
  }
`;

const Select = styled.select`
  padding: 10px;
  width: 200px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: 0.3s;
  background: white;
  
  &:focus {
    border-color: #4a90e2;
    outline: none;
    box-shadow: 0 0 5px rgba(74, 144, 226, 0.5);
  }
`;

const ChartContainer = styled.div`
  width: 100%;
  max-width: 800px;
  background: #222;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 15px green;
  /*animation: fadeIn 0.5s ease-in-out;*/
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 0 25px limegreen;
  }
`;
const StockContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: #111;
`;

const Content = () => {
  const baseURLNews = "https://jamestan-bmake2025-b-89.deno.dev/news?n=";
  const baseURLLaws = "https://jamestan-bmake2025-b-89.deno.dev/laws?n=";
  const baseURLStocks = "https://jamestan-bmake2025-b-89.deno.dev/stocks";
  const baseURLAdvice = "https://jamestan-bmake2025-b-89.deno.dev/advice"
  const [news, setNews] = useState([]);
  const [laws, setLaws] = useState([]);
  const [stocks, setStocks] = useState([])
  const [stock, setStock] = useState(undefined);
  const [stockData, setStockData] = useState([])
  const [advice, setAdvice] = useState([])

  useEffect(() => {
    axios.get(baseURLNews).then((response) => {
      setNews(response.data);
    });
    axios.get(baseURLLaws).then((response) => {
        setLaws(response.data)
    });
    axios.get(baseURLAdvice).then((response) => {
        setAdvice(response.data[0])
    });
    axios.get(baseURLStocks).then((response) => {
      setStocks(response.data);
      setStock(response.data[0]);
    });
  }, []);

  useEffect(() => {
    axios.post(baseURLStocks, { ticker: stock }).then((response) => {
      if (stock == null) return;
      setStockData(response.data);
      console.log(response.data);
    });
  }, [stock]);

  return (
    <ContentContainer>
      <div>
        <Header>
          <h1>Sentiment Analysis Tool</h1>
        </Header>
        <h2>Latest News</h2>
        <div className="rows">
        <ScrollableCard>
          
          {news.length > 0 ? (
            <ul>
              {news.map((item, index) => (
                <li key={index}>
                  <strong>{item.title}</strong>
                  <p>{item.description}</p>
                </li>
              ))}
            </ul>
          ) : (
            <p>Loading...</p>
          )}
        </ScrollableCard>
        <ScrollableCard>
          {laws.length > 0 ? (
            <ul>
              {laws.map((item, index) => (
                <li key={index}>
                  <strong>{item.number}</strong>
                  <p>{item.title}</p>
                </li>
              ))}
            </ul>
          ) : (
            <p>Loading...</p>
          )}
        </ScrollableCard>
        <ScrollableCard>
            <p>
            {advice.advice}
            </p>
          <audio controls>
            <source src={process.env.PUBLIC_URL + '/sonic.mp3'} type="audio/mp3"/>
          </audio>
            
        </ScrollableCard>
        </div>
        <StockContainer>
          <Select onChange={(e) => setStock(e.target.value)}>
            {(stocks.length > 0) && stocks.map(s => <option key={s} value={s}>{s}</option>)}
          </Select>
          <ChartContainer>
            <StockChart data={stockData}/>
          </ChartContainer>
        </StockContainer>
      </div>
    </ContentContainer>
  );
};

export default Content;
